import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import api from '../../api/api';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class TableDirecciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            direcciones: [],
            selectedRow: null
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.direcciones != this.props.direcciones) || (this.state.direcciones != this.props.direcciones)) {
            this.setState({ direcciones: this.props.direcciones });
        }
    }

    static propTypes = {
        direcciones: PropTypes.array,
        action: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    }

    onChange = data => {
        this.setState(
            prevState => ({
                direcciones: prevState.direcciones.concat(data)
            }),
            () => {
                if (this.props.onChange) this.props.onChange(this.state.direcciones);
            }
        );
    }

    onDelete = row => {
        this.setState(
            prevState => {
                prevState.direcciones.splice(row, 1);
                return {
                    direcciones: prevState.direcciones,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.direcciones);
            }
        );
    }

    onEdit = (data, row) => {
        this.setState(
            prevState => {
                prevState.direcciones[row] = data;
                return {
                    direcciones: prevState.direcciones,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.direcciones);
            }
        );
    }

    render() {
        const { direcciones, selectedRow } = this.state;
        const { action } = this.props;
        return (
            <div className="ui-contact-table">
                { (action === 'CREATE' || action === 'EDIT') &&
                    <Fragment>
                        <ModalDirecciones
                            onChange={this.onChange}
                            action="create"
                        />
                        <ModalDirecciones
                            onEdit={this.onEdit}
                            value={direcciones[selectedRow]}
                            row={selectedRow}
                            action="edit"
                        />
                    </Fragment>
                }
                <ModalDirecciones
                    value={direcciones[selectedRow]}
                    row={selectedRow}
                    action="detail"
                />
                { (action === 'CREATE' || action === 'EDIT') &&
                    <ModalDirecciones
                        onDelete={this.onDelete}
                        value={direcciones[selectedRow]}
                        row={selectedRow}
                        action="delete"
                    />
                }
                <Table size="sm" className="ui-contact-table-grid">
                    <thead>
                        <tr>
                            <th>Calle</th>
                            <th>Nro.</th>
                            <th>Ciudad</th>
                        </tr>
                    </thead>
                    <tbody>
                        { direcciones.map(
                            (direccion, i) =>
                                <tr
                                    key={i}
                                    className={selectedRow === i ? 'is-selected' : ''}
                                    onClick={() => this.setState(prevState => ({
                                        selectedRow: prevState.selectedRow === i ? null : i
                                    }))}
                                >
                                    <td>{direccion.direccion}</td>
                                    <td>{direccion.numero}</td>
                                    <td>{direccion.ciudad}</td>
                                </tr>
                            )
                        }
                        { direcciones.length === 0 &&
                            <tr>
                                <td className="text-center ui-contact-table-empty" colSpan={3}>No hay direcciones</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

class ModalDirecciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calle: '',
            numero: null,
            piso: '',
            descripcion: '',
            ciudad: '',
            localidad_id: null,
            provincia_id: null,
            isOpen: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { isOpen } = this.state;
        const { action } = this.props;
        if (action === 'create' && isOpen !== prevState.isOpen && isOpen) {
            try {
                const config = localStorage.configuraciones ? JSON.parse(localStorage.configuraciones) : null;
                if (config && config.provincia_id && config.localidad_id) {
                    this.setState({
                        provincia_id: config.provincia_id,
                        localidad_id: config.localidad_id,
                    });
                }
            } catch(e) {
                console.error(e);
            }
        }
    }

    static propTypes = {
        action: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        disabled: PropTypes.bool
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                id: nextProps.value.id,
                calle: nextProps.value.direccion,
                numero: nextProps.value.numero,
                piso: nextProps.value.piso,
                descripcion: nextProps.value.descripcion,
                localidad_id: nextProps.value.localidad_id,
                ciudad: nextProps.value.ciudad,
                provincia_id: nextProps.value.provincia_id
            });
        }
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar dirección',
            button: 'Eliminar',
            disabled: true,
            buttonColor: 'danger'
        },
        create: {
            icon: 'fa fa-plus',
            color: 'secondary',
            title: 'Agregar dirección',
            button: 'Agregar',
            disabled: false,
            buttonColor: 'success'
        },
        detail: {
            icon: 'fa fa-search',
            color: 'secondary',
            title: 'Ver dirección',
            button: false,
            disabled: true
        },
        edit: {
            icon: 'fa fa-pencil',
            color: 'secondary',
            title: 'Editar dirección',
            button: 'Guardar',
            disabled: false,
            buttonColor: 'success'
        }
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    close = () => {
        if (this.props.action === 'create') {
            this.setState({
                id: undefined,
                calle: '',
                numero: '',
                piso: '',
                descripcion: '',
                ciudad: '',
                localidad_id: null,
                provincia_id: null
            });
        }
        this.toggle();
    }

    onChangeField = (field, value) => {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    onSubmit = () => {
        const { action, row } = this.props;
        const { calle, numero, piso, descripcion, localidad_id, provincia_id, ciudad, id } = this.state;

        if (calle === '') {
            return this.setState({ errors: { calle: [{detail: 'Debe ingresar una dirección.'}] } });
        //} else if (numero === '') {
          //  return this.setState({ errors: { numero: [{detail: 'Debe ingresar un número.'}] } });
        } else if (!localidad_id) {
            return this.setState({ errors: { localidad_id: [{detail: 'Debe seleccionar una ciudad.'}] } });
        }

        if (action === 'create') {
            this.props.onChange({ direccion: calle, numero, piso, descripcion, localidad_id, ciudad, provincia_id });
        } else if (action === 'edit') {
            this.props.onEdit({ direccion: calle, numero, piso, descripcion, localidad_id, ciudad, id, provincia_id }, row);
        } else if (action === 'delete') {
            this.props.onDelete(row);
        }
        this.close();
    }

    render() {
        const { isOpen, provincia_id } = this.state;
        const { action, disabled, row } = this.props;
        const actionData = this.actionData[action];
        return (
            <Fragment>
                { !disabled &&
                    <Button
                        color={actionData['color']}
                        onClick={this.toggle}
                        size="sm"
                        className="mr-1 btn-table-modal rounded"
                        disabled={(action === 'detail' || action === 'delete' || action === 'edit') && (row === null)}
                    >
                        <i className={actionData['icon']} aria-hidden="true"></i>
                    </Button>
                }

                <Modal isOpen={isOpen} toggle={this.toggle} className={"ui-paradigma-modal" + (action === 'delete' ? " modal-danger" : "")}>
                    <ModalHeader toggle={this.toggle}>
                        { actionData['title'] }
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos de la dirección</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    disabled={actionData['disabled']}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Calle"}
                                    maxLength={200}
                                    value={this.state.calle}
                                    error={this.state.errors && this.state.errors.calle}
                                    onChange={e => this.onChangeField('calle', e.target.value)}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Número"}
                                    inputComponent={
                                        <Input
                                            disabled={actionData['disabled']}
                                            maxLength={50}
                                            value={this.state.numero}
                                            onChange={e => {
                                                e.persist();
                                                this.setState(prevState => ({
                                                    numero: /^\d*$/.test(e.target.value) ? e.target.value : prevState.numero
                                                }));
                                            }}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    disabled={actionData['disabled']}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Piso"}
                                    maxLength={10}
                                    value={this.state.piso}
                                    onChange={e => this.onChangeField('piso', e.target.value)}
                                />
                                <ParadigmaLabeledInput
                                    label="Provincia"
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    error={this.state.errors && this.state.errors.provincia_id}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            disabled={actionData['disabled']}
                                            url={api.geograficas.provincias}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['nombre']
                                            }}
                                            displayField="nombre"
                                            value={provincia_id}
                                            onChange={data => this.setState({ provincia_id: (data)? data.id: null, localidad_id: null })}
                                        />
                                    }
                                />
                                <div className="ui-span-2">
                                    <ParadigmaLabeledInput
                                        label="Ciudad"
                                        md={[12, 12]}
                                        classNames={["ui-field-label-col", "ui-field-control-col"]}
                                        error={this.state.errors && this.state.errors.localidad_id}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                disabled={!this.state.provincia_id || actionData['disabled']}
                                                url={provincia_id ? `${api.geograficas.localidades}` : ''}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    sort:['nombre'],
                                                    concat:`provincia=${provincia_id}`
                                                }}
                                                displayField="nombre"
                                                value={this.state.localidad_id}
                                                onChange={data => this.setState({ localidad_id: (data)? data.id: null, ciudad: (data)? data.nombre : '' })}
                                            />
                                        }
                                    />
                                </div>
                                <div className="ui-span-2">
                                    <ParadigmaLabeledInput
                                        disabled={actionData['disabled']}
                                        md={[12, 12]}
                                        classNames={["ui-field-label-col", "ui-field-control-col"]}
                                        label={"Descripción"}
                                        type="textarea"
                                        value={this.state.descripcion}
                                        onChange={e => this.onChangeField('descripcion', e.target.value)}
                                    />
                                </div>
                            </div>
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Cancelar</Button>
                        { actionData['button'] &&
                            <Button color={actionData['buttonColor']} onClick={this.onSubmit} className="mr-1">
                                {actionData['button']}
                            </Button>
                        }
                    </ModalFooter>
                </Modal>

            </Fragment>
        );
    }
}

export default TableDirecciones;



// WEBPACK FOOTER //
// ./src/views/Clientes/TableDirecciones.js